import PropTypes from "prop-types";
import { Fragment, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import usePrevious from "react-use/lib/usePrevious";
import { v4 } from "uuid";

import { addCard, openmobileImage, promoteToCommander, removeCard, setViewerImage } from "store/clipboard";
import { cardRichType } from "types";

import ClipboardItem from "./ClipboardItem";

const ClipboardItems = ({ commander, lists, recs }) => {
  const dispatch = useDispatch();
  const recsRef = useRef(null);
  const commanderColorId = commander ? commander.color_identity : ["W", "U", "B", "R", "G"];
  const prevRecs = usePrevious(recs);

  useEffect(() => {
    if (prevRecs?.length === 0 && recs.length > 0) {
      recsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [recs]);

  const handleShow = (card) => {
    dispatch(setViewerImage(card.image_uri));
    dispatch(openmobileImage());
  };

  return (
    <>
      {commander && (
        <Fragment key={v4()}>
          <div className="w-100" key="commander">
            Commander
          </div>
          <ClipboardItem
            card={commander}
            key={commander.name}
            legal
            legal_commander
            onRemove={() => dispatch(removeCard(commander.url))}
            onShow={() => handleShow(commander)}
            type="commander"
          />
        </Fragment>
      )}
      {Object.values(lists)
        .filter((list) => list.cards.length > 0)
        .sort((a, b) => a.i - b.i)
        .map((list) => {
          list.cards.sort((a, b) => a.cmc - b.cmc);
          return (
            <Fragment key={list.plural}>
              <div className="w-100">{`${list.plural} (${list.cards.length})`}</div>
              {list.cards.map((card) => (
                <ClipboardItem
                  card={card}
                  key={card.name}
                  legal={
                    !card.color_identity ||
                    card.color_identity.filter((c) => !commanderColorId.includes(c)).length === 0
                  }
                  legal_commander={card.legal_commander}
                  onPromote={() => dispatch(promoteToCommander(card))}
                  onRemove={() => dispatch(removeCard(card.url))}
                  onShow={() => handleShow(card)}
                  type="card"
                />
              ))}
            </Fragment>
          );
        })}
      {recs.length > 0 && (
        <Fragment key={v4()}>
          <div className="w-100" key="recs" ref={recsRef}>
            Recs
          </div>
          {recs.map((card, recsIndex) => (
            <ClipboardItem
              card={card}
              key={card.name}
              legal
              onAdd={() => dispatch(addCard({ card, recsIndex }))}
              onPromote={() => dispatch(promoteToCommander(card))}
              onShow={() => handleShow(card)}
              type="rec"
            />
          ))}
        </Fragment>
      )}
    </>
  );
};

ClipboardItems.propTypes = {
  commander: PropTypes.object, // TODO: refactor clipboard to use shared card type
  lists: PropTypes.objectOf(
    PropTypes.shape({
      cards: PropTypes.arrayOf(PropTypes.any), // TODO: refactor clipboard to use shared card type
      i: PropTypes.number,
      plural: PropTypes.string,
    })
  ),
  recs: PropTypes.arrayOf(cardRichType), // TODO: refactor clipboard to use shared card type
};

export default ClipboardItems;
